import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './Spinner.scss.js';

const bem = Bem.create("vai-spinner");
const bouncers = [1, 2, 3];
const Spinner = React.forwardRef(function Spinner2(props, ref) {
  const { htmlId, dataTa = "vai-spinner", className } = props;
  const id = useId(htmlId, ["spinner"]);
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": dataTa,
    className: addClass(bem.block(), className),
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 0,
    ref
  }, bouncers.map((key) => /* @__PURE__ */ React.createElement("span", {
    key,
    className: bem.element("bounce")()
  })));
});

export { Spinner };
